<template>
  <div class="cupon-wrapper">
    <div class="cupon-box" :class="{ open: showInput, applied: couponApplied }" @click="!couponApplied && toggleInput()">
      <div class="cupon-content">
        <img class="icon" src="/images/iconos/ticket-discount.svg"/>
        <div class="text">
          <p v-if="!couponApplied">Agregar cupón</p>
          <p v-if="!couponApplied">de descuento</p>
          <p v-if="couponApplied">Cupón aplicado</p>
          <p v-if="couponApplied" class="coupon-code">{{ coupon }}</p>
        </div>
        <img 
          v-if="!couponApplied"
          src="/images/iconos/arrow_down.svg" 
          alt="arrow" 
          class="chevron" 
          :class="{ open: showInput }"
        />
        <img 
          v-if="couponApplied"
          src="/images/featured/close-circle-primary.svg" 
          alt="remove" 
          class="remove-icon"
          @click.stop="removeCoupon"
        />
      </div>
    </div>
    <!-- Dropdown desplegable -->
    <div class="cupon-input" v-if="showInput && !couponApplied">
      <form @submit.prevent="applyCupon">
        <input
          type="text"
          v-model="cuponCode"
          placeholder="Ingresa el número de cupón de descuento"
          maxlength="16"
          @input="cuponCode = $event.target.value.toUpperCase()"
          :disabled="isValidating"
        />
        <div v-if="couponError" class="error-message">
          El código del cupón ingresado no es válido.
        </div>
        <button type="submit" :disabled="!cuponCode || isValidating">
          {{ isValidating ? 'Validando...' : 'Aplicar' }}
        </button>
      </form>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    // Datos necesarios para validar el cupón
    studentData: {
      type: Object,
      default: () => ({})
    },
    programData: {
      type: Object, 
      default: () => ({})
    },
    selectedCourses: {
      type: Array,
      default: () => []
    },
    locationId: {
      type: [String, Number],
      default: null
    },
    // Cupón actual desde el store
    currentCoupon: {
      type: String,
      default: null
    }
  },
  
  data() {
    return {
      showInput: false,
      cuponCode: "",
      coupon: null,
      couponApplied: false,
      couponError: false,
      isValidating: false,
      validCoupon: false,
      valueCoupon: 0
    };
  },
  
  watch: {
    // Watcher para sincronizar con el cupón del store
    currentCoupon: {
      handler(newCoupon) {
        if (newCoupon) {
          // Si hay cupón en el store, aplicarlo localmente
          this.coupon = newCoupon;
          this.couponApplied = true;
          this.showInput = false;
          this.couponError = false;
        } else {
          // Si no hay cupón en el store, limpiar localmente
          this.removeCoupon();
        }
      },
      immediate: true
    }
  },
  
  methods: {
    toggleInput() {
      this.showInput = !this.showInput;
      if (this.showInput) {
        this.couponError = false;
      }
    },
    
    async applyCupon() {
      if (!this.cuponCode.trim()) {
        alert("Por favor, ingresa un cupón de descuento");
        return;
      }
      
      // Solo guardar el cupón temporalmente, sin validar
      this.coupon = this.cuponCode;
      this.couponApplied = true;
      this.showInput = false;
      this.couponError = false;
      
      // Emitir evento al componente padre con el cupón guardado temporalmente
      this.$emit('coupon-applied', {
        coupon: this.coupon,
        isTemporary: true, // Indicar que es temporal
        isValid: null // No se ha validado aún
      });
    },
    
    removeCoupon() {
      this.coupon = null;
      this.couponApplied = false;
      this.validCoupon = false;
      this.valueCoupon = 0;
      this.cuponCode = "";
      this.couponError = false;
      this.showInput = false;
      
      // Emitir evento al componente padre
      this.$emit('coupon-removed');
    }
  }
};
</script>

<style scoped>
.cupon-wrapper {
  position: absolute !important;
  top: 80px;
  right: 0;
  z-index: 9999;
  width: 211px;
  pointer-events: all;
}

.cupon-box {
  background-color: #009a87;
  color: white;
  border-bottom-left-radius: 16px;
  padding: 12px;
  width: 100%;
  height: 68px;
  cursor: pointer;
  opacity: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.15);
  position: relative;
  transition: all 0.3s ease;
}

.cupon-box.applied {
  background-color: #009a87;
  cursor: default;
}

.cupon-box.open {
  border-bottom-left-radius: 0;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.15);
}

.cupon-content {
  display: flex;
  align-items: center;
  gap: 8px;
}

.icon {
  height: 1.5rem;
  padding: 3px;
  filter: brightness(0) invert(1);
}

.text p {
  color: white;
  margin: 0;
  line-height: 1.2;
  font-size: 0.9rem;
}

.coupon-code {
  font-weight: bold;
  font-size: 0.8rem !important;
}

.chevron {
  margin-left: auto;
  width: 19px;
  height: 19px;
  transition: transform 0.3s ease;
  filter: brightness(0) invert(1);
}

.chevron.open {
  transform: rotate(180deg);
}

.remove-icon {
  margin-left: auto;
  width: 19px;
  height: 19px;
  cursor: pointer;
  filter: brightness(0) invert(1);
  transition: transform 0.2s ease;
}

.remove-icon:hover {
  transform: scale(1.1);
}

.cupon-input {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background-color: #009a87;
  color: white;
  border-bottom-left-radius: 16px;
  border-bottom-right-radius: 16px;
  padding: 12px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
  opacity: 0;
  transform: translateY(-2px);
  animation: dropdownIn 0.3s ease-out forwards;
  border-top: 1px solid rgba(255, 255, 255, 0.1);
}

@keyframes dropdownIn {
  from {
    opacity: 0;
    transform: translateY(-2px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.cupon-input input {
  padding: 10px 12px;
  border-radius: 6px;
  border: none;
  outline: none;
  font-size: 0.9rem;
  width: 100%;
  box-sizing: border-box;
  margin-bottom: 8px;
  color: #333;
}

.cupon-input input:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

.cupon-input input::placeholder {
  color: #999;
}

.error-message {
  color: #ff6b6b;
  font-size: 0.8rem;
  margin-bottom: 8px;
  padding: 4px 0;
}

.cupon-input button {
  background-color: #007d6c;
  color: white;
  border: none;
  padding: 10px 12px;
  border-radius: 6px;
  cursor: pointer;
  font-weight: 500;
  font-size: 0.9rem;
  width: 100%;
  transition: background-color 0.2s ease;
}

.cupon-input button:hover:not(:disabled) {
  background-color: #006558;
}

.cupon-input button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.cupon-input button:active:not(:disabled) {
  transform: translateY(1px);
}

/* Responsive design */
@media (max-width: 768px) {
  .cupon-wrapper {
    top: 130px;
    width: 180px;
  }
  
  .cupon-box {
    height: 60px;
  }
  
  .text p {
    font-size: 0.8rem;
  }

  .cupon-box {
    border-radius: 16px;
  }

  .cupon-input {
    border-radius: 16px;
  }

}
</style>
